export enum ContentTypesEnum {
  VIDEO = "VIDEO",
  AUDIO = "AUDIO",
  IMAGE = "IMAGE",
  GIF = "GIF",
}
